import axios from 'axios';

const getTabelasPreco = params => axios.get('/tabelas-preco', {
  params,
});

const getItensTabelaPreco = params => axios.get('/tabelas-preco/itens', {
  params,
});

const get = id => axios.get(`/tabelas-preco/${id}`);

const save = (tabelaPreco) => {
  if (tabelaPreco.id) {
    return axios.put(`/tabelas-preco/${tabelaPreco.id}`, tabelaPreco);
  }
  return axios.post('/tabelas-preco', tabelaPreco);
};

const remove = id => axios.delete(`/tabelas-preco/${id}`);

export default {
  get,
  getTabelasPreco,
  getItensTabelaPreco,
  save,
  remove,
};
